<template>
  <v-avatar :color="color" :size="backroundsize">
    <span
      class="text-white text-uppercase"
      :style="{ fontSize: initialsFontSize, lineHeight: 1 }"
    >{{ avatarText }}</span>
  </v-avatar>
</template>

<script>
export default {
  name: "Avatar",
  props: ["fullname", "color", "small", "large"],

  data() {
    return {};
  },

  methods: {},

  computed: {
    avatarText() {
      if(this.fullname){
      var firstLetters = this.fullname.match(/\b(\w)/g);
      var acronym = firstLetters.join("");
      var avatarText = "";
      if (acronym.length < 2) {
        avatarText = acronym + this.fullname[this.fullname.length - 1];
      } else if (acronym.length === 2) {
        avatarText = acronym;
      } else {
        avatarText = acronym[0] + acronym.slice(-1);
      }
      return avatarText;
      }
      else{
        return '??'
      }
    },

    backroundsize() {
      if (this.small) {
        return 25;
      } else if (this.large) {
        return 80;
      } else {
        return 38;
      }
    },

    /** ~38% of avatar diameter keeps initials readable across small / default / large */
    initialsFontSize() {
      const n = Number(this.backroundsize) || 38;
      return `${Math.max(10, Math.round(n * 0.38))}px`;
    },
  },

  watch: {},
};
</script>

